import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=2759265f&scoped=true"
import script from "./product_list.vue?vue&type=script&lang=js"
export * from "./product_list.vue?vue&type=script&lang=js"
import style0 from "./product_list.vue?vue&type=style&index=0&id=2759265f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2759265f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2759265f')) {
      api.createRecord('2759265f', component.options)
    } else {
      api.reload('2759265f', component.options)
    }
    module.hot.accept("./product_list.vue?vue&type=template&id=2759265f&scoped=true", function () {
      api.rerender('2759265f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/channelPoolVague/channelPoolDetails/form/product_list.vue"
export default component.exports